import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GiSilverBullet } from "react-icons/gi";
import { BsAwardFill } from "react-icons/bs";
import { FcRating } from "react-icons/fc";
import { Dropdown } from "@mui/base/Dropdown";
import { Menu } from "@mui/base/Menu";
import { MenuButton } from "@mui/base/MenuButton";
import { MenuItem } from "@mui/base/MenuItem";
import { RiCloseCircleFill } from "react-icons/ri";
import "./style/sidefilter.css";
import TopbarFilter from "../Topbar/TopbarFilter";
import allPrdData from "../../../json/product.json";
import { IoColorWandOutline } from "react-icons/io5";

function FastFilter(props) {
  const {
    filter,
    setFilteredItems,
    selectedFilters,
    setOpenAccordions,
    setSelectedFilters,
  } = props;
  console.log("fastfilter selectedFilters", selectedFilters, props);

  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [materialData, setMaterialData] = useState(false);
  const [colorData, setColorData] = useState(false);
  const [selectedColor, setSelectedColor] = useState(false);
  const [bestSelling, setBestSelling] = useState(false);
  const [topRated, setTopRated] = useState(false);

  const location = useLocation();
  const searchParams1 = new URLSearchParams(location.search);
  const prdid = searchParams1.get("prdcategory");

  const clearFilters = () => {
    setDiscountEnabled(false);
    setMaterialData(false);
    setSelectedColor(false);
    setTopRated(false);
    setBestSelling(false);
    setColorData(false);
  };
  const colorFilter = (color) => {
    setSelectedColor(color);
  };

  useEffect(() => {

    let filteredData = [...allPrdData?.newPrd];

    if (discountEnabled) {
      filteredData = allPrdData?.newPrd?.filter(
        (item) => item.prddiscount === "enable"
      );
    }
    if (materialData) {
      filteredData = allPrdData?.newPrd?.filter(
        (item) => item.jwelleryMaterial === "Silver"
      );
    }
    if (selectedColor) {
      filteredData = filteredData?.filter(
        (item) => item.jwelleryColour === selectedColor
      );
    }
    if (colorData) {
      filteredData = filteredData?.filter(
        (item) => item.jwelleryColour === "White"
      );
    }
    if (bestSelling) {
      filteredData = filteredData?.sort((a, b) => b.salesCount - a.salesCount);
    }
    if (topRated) {
      filteredData = allPrdData?.newPrd?.filter((item) => item.rating === 5);
     
    }
    setFilteredItems(filteredData);
  }, [
    allPrdData,
    prdid,
    discountEnabled,
    materialData,
    selectedColor,
    colorData,
    bestSelling,
    topRated,
  ]);

    return (
        <div>
            <div className='ms-5 mt-10 fast-filter'>
                <span className='mt-1 p-1 text-lg w-28'>Fast Filter</span>
                <ul className='flex flex-wrap' >
                    {(discountEnabled || materialData || selectedColor ||  bestSelling || topRated || colorData) &&
                        <p className='border py-2 px-5 flex  mt-1 btn-border-radius text-sm' onClick={clearFilters}><RiCloseCircleFill className='mt-1 mr-2' />REMOVE All</p>
                    }
                    {/* <li><p className={`border py-2 px-5 flex  mt-1 btn-border-radius text-sm cursor-pointer ${discountEnabled ? 'bg-red-100' : ''}`} onClick={() => setDiscountEnabled(!discountEnabled)}><AiFillTag className='mt-1 text-red-300 mr-2' /> DISCOUNT</p></li> */}
                    <li><p className={`border py-2 px-5 flex ms-1 mt-1 btn-border-radius text-sm cursor-pointer ${materialData ? 'bg-brown-100' : ''}`} onClick={() => setMaterialData(!materialData)}><GiSilverBullet className='mt-1 text-brown-400 mr-2' />SLIVER</p></li>
                    <li><p className={`border py-2 px-5 flex m-1 btn-border-radius text-sm cursor-pointer ${colorData ? 'bg-orange-100' : ''}`} onClick={() => setColorData(!colorData)}><IoColorWandOutline className='mt-1 mr-2' />White Color</p></li>
                    <li><p className={`border py-2 px-5 flex m-1 btn-border-radius text-sm cursor-pointer ${bestSelling ? 'bg-indigo-100' : ''}`} onClick={() => setBestSelling(!bestSelling)}><BsAwardFill className='mt-1 text-red-900 mr-2' />BEST SELLING</p></li>
                    <li><p className={`border py-2 px-5 flex m-1 btn-border-radius text-sm cursor-pointer ${topRated ? 'bg-indigo-100' : ''}`} onClick={() => setTopRated(!topRated)}><FcRating className='mt-1 mr-2' />TOP RATED</p></li>
                    <li className='mt-1'>
                        <Dropdown className='me-10 '>
                            <MenuButton className={`border py-2 px-5 flex  btn-border-radius  text-sm  ${selectedColor ? 'bg-orange-100' : ''}`} >SELECT COLOUR</MenuButton>
                            <Menu style={{ zIndex: '565655', padding: '15px', backgroundColor: 'white', borderRadius: '10px', }} className='cursor-pointer border'>
                                <MenuItem className={`cursor-pointer border py-2 px-5 flex my-1 btn-border-radius  text-sm p-2 ${selectedColor ? 'bg-orange-100' : ''}`} onClick={() => colorFilter("White")}>White</MenuItem>
                                <MenuItem className={`cursor-pointer border py-2 px-5 flex my-1 btn-border-radius  text-sm p-2 ${selectedColor ? 'bg-orange-100' : ''}`} onClick={() => colorFilter("Gold colour")}>Gold</MenuItem>
                                <MenuItem className={`cursor-pointer border py-2 px-5 flex my-1 btn-border-radius  text-sm p-2 ${selectedColor ? 'bg-orange-100' : ''}`} onClick={() => colorFilter("Rose gold")}>Rose Gold</MenuItem>
                                <MenuItem className={`cursor-pointer border py-2 px-5 flex my-1 btn-border-radius  text-sm p-2 ${selectedColor ? 'bg-orange-100' : ''}`} onClick={() => colorFilter("Yellow")}>Yellow</MenuItem>
                            </Menu>
                        </Dropdown>
                    </li>

                </ul>
            </div>
             <div className='flex justify-end me-12'>
                <div className=' text-end sidefilter-show hidden' >
                    <TopbarFilter filter={filter} selectedFilters={selectedFilters} setOpenAccordions={setOpenAccordions} setSelectedFilters={setSelectedFilters}/>
                </div>
               {/* <ul>
                    <li className=' ms-1'>
                        <Dropdown className='me-10 '>
                            <MenuButton className={`border py-2 px-5 flex  btn-border-radius  text-sm  ${sortByPrice ? 'bg-indigo-100' : ''}`} >SORT BY AVERAGE RATING <IoIosArrowDown className='m-1' /></MenuButton>
                            <Menu style={{ zIndex: '565655', padding: '15px 8px', backgroundColor: 'white', borderRadius: '10px', cursor: 'pointer' }} >
                                <MenuItem className='cursor-pointer border py-2 px-2 flex my-1 btn-border-radius  text-sm p-2' onClick={() => handleSortChange('asc')}>Sort price: Low to high</MenuItem>
                                <MenuItem className='cursor-pointer border py-2 px-2 flex my-1 btn-border-radius  text-sm p-2' onClick={() => handleSortChange('desc')}>Sort price: high to Low</MenuItem>
                                <MenuItem className='cursor-pointer border py-2 px-2 flex my-1 btn-border-radius  text-sm p-2' >Sort by average rating</MenuItem>
                            </Menu>
                        </Dropdown>
                    </li>
                </ul>*/}
            </div> 


        </div>
    );
}

export default FastFilter;
